import { styled } from '@linaria/react';
import { colors, fonts, layout, semantic, space } from '../../theme/tokens';

export const StyledBadge = styled.span`
  display: inline-block;
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.semiBold};
  background: ${semantic.bg.urgencyStrong};
  color: ${colors.white};
  padding: ${space[1]} 10px;
  border-radius: ${space[1]};
  letter-spacing: 0.2px;

  &[data-tone='neutral'] {
    background: ${semantic.bg.surfaceSubtle};
    color: ${semantic.text.secondary};
    padding: 2px ${space[2]};
    border-radius: ${layout.borderRadiusLg};
    letter-spacing: normal;
  }

  &[data-tone='success'] {
    background: ${semantic.bg.positiveSubtle};
    color: ${semantic.text.positive};
    padding: ${space[1]} ${space[3]};
    border-radius: ${layout.borderRadiusFull};
    font-weight: ${fonts.weight.medium};
    letter-spacing: normal;
  }
`;
